module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0040.jpg?v=be60051f";